<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Credit Note #{{data.code}}</h4>
                    <p class="text-subtitle-1">Supplier Credit Note Information</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(this.perm.credit_note.post) && data.state_code == stateDraft">
                    <v-btn block color="primary" @click="handlePost" :loading="postLoading">
                        <v-icon left>mdi-post</v-icon>
                        post
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block :depressed="data && data.state_code == stateDraft" :color="data && data.state_code == statePosted ? 'primary' : ''" @click="handlePrint">
                        <v-icon left>mdi-printer</v-icon>
                        print
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.credit_note.update) && (data && data.state_code == stateDraft)">
                    <v-btn block depressed @click="handleEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        edit
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.credit_note.delete) && (data && data.state_code == stateDraft)">
                    <v-btn block depressed color="error--text" @click="handleDelete" :loading="deleteLoading">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <CreditNote :value="data"/>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PAlert from './../../components/common/PAlert.vue'
import CreditNote from './../../components/purchase/CreditNote.vue'
import { mapActions } from 'vuex'
import authorize from '../../utils/authorize';
export default {
    name: "CreditNoteDisplayView",
    components: {
        CreditNote,
        PAlert
    },
    data() {
        return {
            id: null,
            data: null,
            loading: false,
            deleteLoading: false,
            alert: {
                title: 'Alert',
                content: "Are You sure",
                value: false,
                callback: null   
            },
            perm: permissions,
            stateDraft: 1,
            statePending: 2,
            statePosted: 3,
            stateRejected: 4
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        ...mapActions({
            findByID: "purchase/creditNote/findByID",
            snackbar: "ui/snackbar/show",
            remove: "purchase/creditNote/remove",
            post: "purchase/creditNote/post",
            print: "purchase/creditNote/print",
        }), 
        handleCreate() {
            this.$router.push({ name: "CreditNoteCreate"})
        },
        handleEdit() {
            this.$router.push({ name: "CreditNoteEdit"})

        },
        handleList() {
            this.$router.push({ name: "CreditNoteList"})
        },
        getAsync() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                let data = response.data;
                let exchangeRate = data.base_amount / data.amount;
                data.lines = data.lines.map(line => {
                    return {
                        ...line,
                        document_amount: line.base_amount / exchangeRate
                    }
                });
                this.data = data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: "error", text: message })
            }).finally(() => {
                this.loading = false
            })
        },
        handlePost() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to want to post?", callback: this.postAsync};
        },
        postAsync() {
            this.postLoading = true;
            this.post(this.data).then(() => {
                this.snackbar({text: "Credit Note Posted", color: "success"});
                setTimeout(this.reload, 800);
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"});
            }).finally(() => {
                this.postLoading = false;
            });
        },
        reload() {
            this.getAsync();
        },
        handlePrint(){
            this.print(this.data)
                .then(response => {
                    var printWindow = window.open('','','width=800,height=600');
                    printWindow.document.write(response.data);
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                    printWindow.close();
                })
                .catch(error => {
                    let message = error.response ? error.response.data.message : error;
                    this.snackbar = { value: true, color: "error", text: message}
                })
        },
        handleDelete() {
            this.alert = {...this.alert,content: "Are You Sure You Want to delete?", value: true, callback: this.deleteAsync }
        },
        deleteAsync() {
            this.deleteLoading = true;
            this.remove(this.data).then(() => {
                this.$router.replace({ name: "CreditNoteList"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.deleteLoading = false
            })
        },
    },
    mounted() {
        this.id = this.$route.params.id;
        this.getAsync()

    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getAsync()
        next();
    }
}
</script>

<style>

</style>